var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.chartComponent,{ref:"chart",tag:"component",staticClass:"va-chart",attrs:{"chartOptions":_vm.chartOptions,"chart-data":_vm.data}})}
var staticRenderFns = []

export { render, staticRenderFns }